import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

import { appConfig } from '@/config/appConfig';

export const routing = defineRouting({
    locales: appConfig.i18n.locales,
    defaultLocale: appConfig.i18n.defaultLocale,
    localeDetection: true,
    localePrefix: 'always',
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
// eslint-disable-next-line @typescript-eslint/naming-convention
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
